module.exports = __webpack_public_path__ + "static/media/molde-sinplantillas.9e9f8994.jpg";